import type { GetPeopleQuery, GetPeopleResponse } from '@clsplus/api-types/api-admin'

import { getTokens } from '../../helpers/auth'

const GET_PEOPLE_LIMIT = 50

function getPeople(query: GetPeopleQuery): Promise<GetPeopleResponse> {
  const tokens = getTokens()
  const url = new URL(`${import.meta.env.VITE_API_URL}admin/people`)

  if (query) {
    Object.entries(query).forEach(([key, value]) => url.searchParams.append(key, value.toString()))
  }

  return fetch(url.toString(), {
    headers: { Authorization: `Bearer ${tokens?.accessToken}` },
  })
    .then(response => response.json())
    .then(data => {
      if (data.error) {
        throw new Error(data.error)
      }

      return data
    })
}

export const peopleQuery = (queryParams: GetPeopleQuery) => ({
  queryKey: ['people', queryParams],
  queryFn: ({ pageParam = 0 }: { pageParam?: number }) =>
    getPeople({
      limit: GET_PEOPLE_LIMIT.toString(),
      offset: pageParam.toString(),
      ...queryParams,
    }),
  getNextPageParam: (lastPage: GetPeopleResponse, pages: GetPeopleResponse[]) => {
    if (lastPage.data.length < GET_PEOPLE_LIMIT) return
    return pages.length * GET_PEOPLE_LIMIT
  },
})
